import React from "react";
import { Link } from "react-router-dom";
import "../../Styles/Feefrequency.css";

export default function VehicleSparepartsDetail1() {
  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Spareparts Details</h4>
        <div className="yc-header-actions">
          <Link to="/updatevehiclespareparts" className="btn btn-primary">Edit</Link>
          <button type="button" className="btn btn-danger">Delete</button>
        </div>
      </div>

      <div className="ff-page-body">
        <div className="card ff-detail-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table ff-detail-table mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold ff-detail-label">Vehicle Name</td>
                    <td>Uber Vehicle</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Spareparts</td>
                    <td>Side Mirror</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Warranty</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Purchase Date</td>
                    <td>Thu Dec 16 2021</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Expiry Date</td>
                    <td>Fri Dec 31 2021</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Quantity</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Amount</td>
                    <td>$2343</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Invoice</td>
                    <td>Not Uploaded</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
